import request from '@/utils/request'

// 企业资讯列表(首页无权限)
export function coalExamineNoAuthList(query) {
    return request({
        url: '/coal/document/dataFormCoalNew/noAuth/queryList',
        method: 'get',
        params: query
    })
}

// 企业资讯列表
export function examineList(query) {
    return request({
        url: '/coal/document/dataFormCoalNew/queryList',
        method: 'get',
        params: query
    })
}

// 企业资讯详情
export function examineDetail(query) {
    return request({
        url: '/coal/document/dataFormCoalNew/examineList',
        method: 'get',
        params: query
    })
}

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/coal/industry/noAuth/industryList',
        method: 'get',
        params: query
    })
}

// 行业动态二级页
export function industryPage(query) {
    return request({
        url: `/coal/industry/charredCoalList`,
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/coal/industry/charredCoalInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)
export function coalReportNoAuthList(query) {
    return request({
        url: '/coal/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表(二级)
export function charredCoalList(query) {
    return request({
        url: '/coal/report/charredCoalList',
        method: 'get',
        params: query
    })
}

// 技术及标准列表(首页)
export function standardNoAuthList(query) {
    return request({
        url: '/coal/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/coal/report/charredCoalTechnicalList',
        method: 'get',
        params: query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/coal/report/charredCoalTechnicalInfo/${id}`,
        method: 'get',
    })
}

// 价格列表(首页无权限)/期货主力合约价格
export function priceNoAuthList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/coalContractList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/进出口
export function coalImportList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/coalImportList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/产地
export function coalPlaceList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/coalPlaceList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/港口
export function coalPortList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/coalPortList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)/仓单
export function coalReceiptList(query) {
    return request({
        url: '/coal/metatron/price/noAuth/coalReceiptList',
        method: 'get',
        params: query
    })
}

// 价格列表 产地
export function pricePageCoalPlaceList(query) {
    return request({
        url: '/coal/metatron/price/coalPlaceList',
        method: 'get',
        params: query
    })
}

// 价格列表 港口
export function pricePageCoalPortList(query) {
    return request({
        url: '/coal/metatron/price/coalPortList',
        method: 'get',
        params: query
    })
}

// 价格列表 进口
export function pricePageCoalImportList(query) {
    return request({
        url: '/coal/metatron/price/coalImportList',
        method: 'get',
        params: query
    })
}


// 价格列表 仓单
export function pricePageCoalReceiptList(query) {
    return request({
        url: '/coal/metatron/price/coalReceiptList',
        method: 'get',
        params: query
    })
}

// 价格列表 期货主力合约价格
export function pricePageCoalContractList(query) {
    return request({
        url: '/coal/metatron/price/coalContractList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function pricePage(query) {
    return request({
        url: '/coal/metatron/price/cokeList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: '/coal/metatron/price/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 价格详情 产地 /metatron/price/detailsCoalPlace
export function priceDetailCoalPlace(query) {
    return request({
        url: '/coal/metatron/price/detailsCoalPlace',
        method: 'get',
        params: query
    })
}

// 价格详情 港口/metatron/price/detailsCoalPort
export function priceDetailCoalPort(query) {
    return request({
        url: '/coal/metatron/price/detailsCoalPort',
        method: 'get',
        params: query
    })
}

// 价格详情 进口
export function priceDetailsCoalImport(query) {
    return request({
        url: '/coal/metatron/price/detailsCoalImport',
        method: 'get',
        params: query
    })
}

// 价格详情 仓单
export function priceDetailCoalReceipt(query) {
    return request({
        url: '/coal/metatron/price/detailsCoalReceipt',
        method: 'get',
        params: query
    })
}

// 价格详情 期货主力合约价格
export function priceDetailCoalContract(query) {
    return request({
        url: '/coal/metatron/price/detailsCoalContract',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockPage(query) {
    return request({
        url: '/coal/metatron/stock/cokeList',
        method: 'get',
        params: query
    })
}


// 开工率列表(首页无权限)
export function coalRateNoAuthList(query) {
    return request({
        url: '/coal/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 开工率列表 /operate/rate/boardList
export function ratePage(query) {
    return request({
        url: '/coal/druidEnter/coalCokeRateList',
        method: 'get',
        params: query
    })
}

// 开工率详情
export function rateDetail(query) {
    return request({
        url: '/coal/druidEnter/getCoalCokeRateDetailInfo',
        method: 'get',
        params: query
    })
}

// 进出口量列表
export function exitPage(query) {
    return request({
        url: '/coal/metatron/exit/cokeList',
        method: 'get',
        params: query
    })
}

// 进出口量列表(首页无权限)
export function exitNoAuthList(query) {
    return request({
        url: '/coal/metatron/exit/noAuth/cokeList',
        method: 'get',
        params: query
    })
}

// 进出口量详情
export function exitDetail(query) {
    return request({
        url: '/coal/metatron/exit/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 新增淘汰产能列表(首页无权限)
export function boardNoAuthList(query) {
    return request({
        url: '/coal/board/noAuth/list',
        method: 'get',
        params: query
    })
}

// 新增淘汰产能详情
export function boardDetail() {
    return request({
        url: `/coal/board/getCapacityList`,
        method: 'get',
    })
}

// 地图
export function mapData(query) {
    return request({
        url: '/coal/metatron/yield/cokeYieldLine',
        method: 'get',
        params: query
    })
}

// 地图/operate/rate/lineChart 开工率
export function ratemapData(query) {
    return request({
        url: '/coal/metatron/price/cokeLineChart',
        method: 'get',
        params: query
    })
}

// 地图
export function mapDatas(query) {
    return request({
        url: '/coal/metatron/price/cokeLineChart',
        method: 'get',
        params: query
    })
}

// 企业产能 （首页无权限）
export function getNoAuthCompanyCoke(query) {
    return request({
        url: '/coal/metatron/companyCoke/noAuth/queryList',
        method: 'get',
        params: query
    })
}

// 研究报告详情 /report/charredCoalTechnicalInfo/{id}
export function coalReportDetail(id) {
    return request({
        url: `/coal/report/charredCoalInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准详情
//全国产量 （首页无权限）
// 企业产能 （详情）
// 企业产能 （按炉型产能分布 ）
export function getListGroupByModel(query) {
    return request({
        url: '/coal/metatron/companyCoke/getListGroupByModel',
        method: 'get',
        params: query
    })
}

// 企业产能 （全国产能焦化区域分布）
// 企业产能 （产能焦化一览）
export function companyCokeList(query) {
    return request({
        url: '/coal/metatron/companyCoke/queryList',
        method: 'get',
        params: query
    })
}

// 讨论区
export function bulletinList(query) {
    return request({
        url: '/coal/bulletin/list',
        method: 'get',
        params: query
    })
}

// 新增讨论
export function addBulletin(data) {
    return request({
        url: '/coal/bulletin',
        method: 'post',
        data: data
    })
}

// 焦煤产量/原煤
export function coalRawYieldList(query) {
    return request({
        url: '/coal/metatron/yield/noAuth/coalRawYieldList',
        method: 'get',
        params: query
    })
}

// 焦煤产量/进出口/metatron/yield/noAuth/coalImportYieldList
export function coalImportYieldList(query) {
    return request({
        url: '/coal/metatron/yield/noAuth/coalImportYieldList',
        method: 'get',
        params: query
    })
}

// 焦煤产量/原煤
export function rawYieldList(query) {
    return request({
        url: '/coal/metatron/yield/coalRawYieldList',
        method: 'get',
        params: query
    })
}

// 焦煤产量/进出口/metatron/yield/noAuth/coalImportYieldList
export function importYieldList(query) {
    return request({
        url: '/coal/metatron/yield/coalImportYieldList',
        method: 'get',
        params: query
    })
}

// 焦煤产量详情
export function detailsCoalRawYield(query) {
    return request({
        url: '/coal/metatron/yield/detailsCoalRawYield',
        method: 'get',
        params: query
    })
}

// 焦煤产量详情/进出口//metatron/yield/detailsCoalImportYield
export function detailsCoalImportYield(query) {
    return request({
        url: '/coal/metatron/yield/detailsCoalImportYield',
        method: 'get',
        params: query
    })
}

// 地图权限
export function mapAuth(query) {
    return request({
        url: '/coal/metatron/map/coalMap',
        method: 'get',
        params: query
    })
}

// 库存无权限
export function stockNoAuthList(query) {
    return request({
        url: '/coal/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}
// 库存列表
export function stockList(query) {
    return request({
        url: '/coal/druidEnter/stockCoalList',
        method: 'get',
        params: query
    })
}

// 详情
export function stockDetail(query) {
    return request({
        url: '/coal/druidEnter/getCoalStockDetailInfo',
        method: 'get',
        params: query
    })
}

// 下游企业列表
export function downstreamList(query) {
    return request({
        url: '/coal/druidEnter/companyCoalList',
        method: 'get',
        params: query
    })
}

// 下游企业详情
export function downstreamDetail(query) {
    return request({
        url: '/coal/druidEnter/getDownCompanyDetailInfo',
        method: 'get',
        params: query
    })
}

// 洗煤厂列表
export function washList(query) {
    return request({
        url: '/coal/druidEnter/washCokePlantCoalList',
        method: 'get',
        params: query
    })
}

// 洗煤厂详情
export function washDetail(query) {
    return request({
        url: '/coal/druidEnter/getWashCokeDetailInfo',
        method: 'get',
        params: query
    })
}

// 三年折线图
export function getLineData(query) {
    return request({
        url: '/coal/druidEnter/getLineChart',
        method: 'get',
        params: query
    })
}


// 外链权限
export function getAuthFlagCoal() {
    return request({
        url: '/coal/metatron/map/coalReportForm',
        method: 'get',
    })
}
// 详情
export function getAuthDetailReport() {
    return request({
        url: '/coal/metatron/map/detailReportForm',
        method: 'get',
    })
}
// 汇总
export function getAuthSummaryReport() {
    return request({
        url: '/coal/metatron/map/summaryReportForm',
        method: 'get',
    })
}
// 对比
export function getAuthCompareReport() {
    return request({
        url: '/coal/metatron/map/compareReportForm',
        method: 'get',
    })
}

// 煤炭竞卖预告列表
export function auctionTrailerList(query) {
    return request({
        url: '/coal/industry/noAuth/industryList',
        method: 'get',
        params: query
    })
}

// 煤炭竞卖预告详情
export function auctionTrailer(id) {
    return request({
        url: '/coal/industry/noAuth/auctionTrailer/' + id,
        method: 'get'
    })
}